import React, { useContext, useReducer, useState } from 'react';
import api from './ApiCall';
import { BATCHPART_LIST, BatchPartContext, CommonContext} from './../constant/ActionTypes';
import { batchPartReducer } from './../reducer/batchPartReducer';
import Modal from './../../common/Modal/Modal';
// import CustomSnackbar from './../../common/Snackbar/Snackbar.js';
import Loader from './../../common/Loader/Loader';

const initialState = {
    batchPartList: []
}

const BatchPartProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [showLoader, setShowLoader] = useState(false);
    const [showErrMsg, setShowErrMsg] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [batchPartState, dispatch] = useReducer(batchPartReducer, initialState);

    const getBatchPartList = (batch_id, page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`BatchPartService/getAll/${batch_id}${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: BATCHPART_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearBatchPartList = () => {
        dispatch({
            type: BATCHPART_LIST,
            payload: []
        });
    }

    // const addBatchPart = (user_list, batch_id) => {
    //     let data = {
    //         user_list, 
    //         batch_id: parseInt(batch_id)
    //     }
    //     api({ contentType: true, auth: true }).post('BatchPartService/add', data)
    //     .then((response) => {
    //         if(response.data.status.toLowerCase() === 'success') {
    //             getBatchPartList(batch_id);
    //         }
    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     });
    // }

    const deleteBatchPart = (id, batch_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).delete(`BatchPartService/delete/${id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getBatchPartList(batch_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Participant deteted successfully');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Participant cannot be deleted');
            }
        });
    }

    // add user
    const addUser = (userdetail, batch_id) => {
        setShowLoader(true);
		let data = {
			firstname: userdetail.firstname,
            lastname: userdetail.lastname,
            phone: userdetail.phone,
            email: userdetail.email.trim(),
            country: userdetail.country,
            city: userdetail.city, 
            batch_id: parseInt(batch_id)
        }
        api({ contentType: true, auth: true }).post('BatchPartService/addparticipant', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success' && response.data.result !== null) {
                commonContext.handleSnackbar(true, 'success', 'Participant added successfully');
                getBatchPartList(batch_id, 1, 25);
            } else {
                commonContext.handleSnackbar(true, 'error', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Participant cannot be added');
            }
        });
    }

    // bulk upload
    const partBulkUpload = (file, batch_id) => {
        setShowLoader(true);
        let data = new FormData();
        data.append('file', file);
        api({ contentType: 'application/x-www-form-urlencoded', auth: true }).post(`bulkprocessing/batchparticipants/${batch_id}`, data)
        .then((response) => {
            if(response.data=== 'Upload Successful..!!!') {
                commonContext.handleSnackbar(true, 'success', "Participants added Successfully");
                getBatchPartList(batch_id, 1, 25);
            } else {
                console.log(response.data.result, 'dsfdsfdsfsd');
                if (response.data.result && response.data.result.length > 0) {
                    setShowErrMsg(true);
                    setErrMsg(response.data.result);
                }
                setShowErrMsg(true);
                setErrMsg(response.data.result);
                commonContext.handleSnackbar(true, 'error', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            setShowLoader(false);
            console.error(error.response.data.errorMessage);
            if(error.response.data.errorMessage) {
                commonContext.handleSnackbar(true, 'error', error.response.data.errorMessage);
            }
        });
    }

    const clearErrMsg = () => {
        setShowErrMsg(false);
        setErrMsg([]);
    }

    return (
        <React.Fragment>
            <BatchPartContext.Provider
                value={{
                    ...batchPartState,
                    getBatchPartList: getBatchPartList,
                    // addBatchPart: addBatchPart,
                    deleteBatchPart: deleteBatchPart,
                    addUser: addUser,
                    clearBatchPartList: clearBatchPartList,
                    partBulkUpload: partBulkUpload
                }}
            >
                {props.children}
                {showLoader && <Loader onlyLoading />}
                {showErrMsg &&
                    <Modal
                        modalOpen={showErrMsg}
                        toggleModal={clearErrMsg}
                        title="Error on Bulk Upload"
                        noActions
                    >
                        <div className="err-table">
                            <div className="err-head">
                                <div>#</div>
                                <div>Submitted Row</div>
                            </div>
                            {errMsg && errMsg.length > 0 && errMsg.map(item => (
                                <div className="err-content">
                                    <div>{item.rowIndex}</div>
                                    <div>
                                        {item.data && typeof item.data === 'string' ? (
                                            <span className='mandatory'>{item.data}</span>
                                        ) : (
                                            <React.Fragment>
                                                {item.data && item.data.length > 0 && item.data.map((val, i) => (
                                                    <span>
                                                        <span className={`
                                                            ${val === 'Invalid Format' ? 'invalid' : ''}
                                                            ${val === 'Missing mandatory' ? 'mandatory' : ''}
                                                        `}>
                                                            {val}
                                                        </span>
                                                        {i < (item.data.length - 1) && ', '}
                                                    </span>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal>
                }
            </BatchPartContext.Provider>
        </React.Fragment>
    );
}

export default BatchPartProvider;



// WEBPACK FOOTER //
// ./contexts/provider/BatchPartContext.js